import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

const EditaTaller = ({ isOpen, toggle, taller, actualizar }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (taller) {
      setFormData({ ...taller });
    }
  }, [taller]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    // ✅ Validación de campos obligatorios (excepto teléfono)
    const camposObligatorios = {
      NIT: formData.nit,
      Sucursal: formData.sucursal,
      "Nombre Taller": formData.nombreTaller,
      Dirección: formData.direccion,
      "Número de Certificado": formData.numeroCertificado,
      Emitido: formData.emitido,
      "Fecha Emisión": formData.fechaEmision,
      "Fecha Vencimiento": formData.fechaVencimiento,
      "Póliza Responsable Civil": formData.polizaResponsableCivil,
      "Última Vigencia Política DL": formData.ultimaVigenciaPoliticaDL,
      Regional: formData.regionalId,
    };

    const faltantes = Object.entries(camposObligatorios)
      .filter(([_, valor]) => !valor || valor.toString().trim() === "")
      .map(([campo]) => campo);

    if (faltantes.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Campos obligatorios faltantes",
        html: `<ul style="text-align:left">
        ${faltantes.map((campo) => `<li>${campo}</li>`).join("")}
      </ul>`,
        confirmButtonText: "Entendido",
      });
      return;
    }

    // ✅ Si pasa validación, ejecutar actualización
    setLoading(true);

    axios
      .put(
        `https://inspecciongnvback.azurewebsites.net/api/v1/ActualizaTalleres/${taller?.id}`,
        formData,
        {
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
          headers: { "Content-Type": "application/json" },
        },
      )
      .then(() => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Actualización exitosa",
          text: "El taller ha sido actualizado correctamente.",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          actualizar();
          toggle();
        });
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error actualizando taller", err);
        Swal.fire({
          icon: "error",
          title: "Error al actualizar",
          text: "Hubo un problema al intentar actualizar el taller.",
          confirmButtonColor: "#d33",
        });
      });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Edita Taller</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>NIT</Label>
                <Input
                  name="nit"
                  value={formData.nit || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Sucursal</Label>
                <Input
                  name="sucursal"
                  value={formData.sucursal || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Nombre Taller</Label>
                <Input
                  name="nombreTaller"
                  value={formData.nombreTaller || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Dirección</Label>
                <Input
                  name="direccion"
                  value={formData.direccion || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Teléfono</Label>
                <Input
                  name="telefono"
                  value={formData.telefono || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Número Certificado</Label>
                <Input
                  name="numeroCertificado"
                  value={formData.numeroCertificado || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Emitido</Label>
                <Input
                  name="emitido"
                  value={formData.emitido || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Fecha Emisión</Label>
                <Input
                  type="date"
                  name="fechaEmision"
                  value={formData.fechaEmision?.split("T")[0] || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Fecha Vencimiento</Label>
                <Input
                  type="date"
                  name="fechaVencimiento"
                  value={formData.fechaVencimiento?.split("T")[0] || ""}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Póliza Responsabilidad Civil</Label>
                <Input
                  name="polizaResponsableCivil"
                  value={formData.polizaResponsableCivil || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Fecha vigencia RC</Label>
                <Input
                  type="date"
                  name="ultimaVigenciaPoliticaDL"
                  value={formData.ultimaVigenciaPoliticaDL?.split("T")[0] || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>ID ROM Chip Validador</Label>
                <Input
                  name="idRomChipValidador"
                  value={formData.idRomChipValidador || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Chip Tanqueo</Label>
                <Input
                  name="chipTanqueo"
                  value={formData.chipTanqueo || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Número de Técnicos</Label>
                <Input
                  type="number"
                  name="numeroTecnicos"
                  value={formData.numeroTecnicos || 0}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Estado</Label>
                <Input
                  name="estado"
                  value={formData.estado || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Regional ID</Label>
                <Input
                  type="number"
                  name="regionalId"
                  value={formData.regionalId || 0}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Usuario ID</Label>
                <Input
                  type="number"
                  name="usuarioId"
                  value={formData.usuarioId || 0}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Poliza Legales</Label>
                <Input
                  name="polizaLegales"
                  value={formData.polizaLegales || ""}
                  onChange={handleChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Fecha Vence Legales</Label>
                <Input
                  type="date"
                  name="fechaVenceLegales"
                  value={formData.fechaVenceLegales?.split("T")[0] || ""}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={loading}>
          {loading ? "Guardando..." : "Guardar Cambios"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditaTaller;
